export const MAIN_CLASS_NAME = 'ib-collapse';
export const PANEL_CLASS_NAME = `${MAIN_CLASS_NAME}__panel`;
